var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description"},[_c('SmallText',[_vm._v(" "+_vm._s(_vm.$t('main'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }